import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ComingSoonRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer/main-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/lboard/board.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/vercel/path0/src/components/nav-bar.tsx");
